import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const MarketingCampaignTableView = Loadable(
  lazy(() =>
    import("./MarketingCampaignTableView").then(({ MarketingCampaignTableView }) => ({
      default: MarketingCampaignTableView,
    }))
  )
);

const MarketCampaignProvider = Loadable(
  lazy(() =>
    import("./SingleMarketCampaign").then(({ MarketCampaignProvider }) => ({
      default: MarketCampaignProvider,
    }))
  )
);

const MarketCampaignLogs = Loadable(
  lazy(() =>
    import("../marketingCampaign/components/marketCampaignLogs").then(({ MarketCampaignLogs }) => ({
      default: MarketCampaignLogs,
    }))
  )
);

const MarketCampaignAudienceTable = Loadable(
  lazy(() =>
    import("./MarketCampaignAudienceTable").then(({ MarketCampaignAudienceTable }) => ({
      default: MarketCampaignAudienceTable,
    }))
  )
);



export const marketCampaignV2Routes = [
  {
    path: REACT_APP_NAV_ROUTES.WhatsAppCampaigns.Campaigns,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MARKETING]}>
        <MarketingCampaignTableView />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${REACT_APP_NAV_ROUTES.WhatsAppCampaigns.Campaigns}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MARKETING]}>
        <MarketCampaignProvider />
      </AuthorizedRoute>
    ),
  },

  {
    path: `/market-campaign/manage/:uuid/:tab?`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MARKETING]}>
        <MarketCampaignProvider />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/market-campaign/logs/:marketCampaignId`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MARKETING]}>
        <MarketCampaignLogs />
      </AuthorizedRoute>
    ),
  },

  {
    path: `/market-campaign-audience`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.MARKETING]}>
        <MarketCampaignAudienceTable />
      </AuthorizedRoute>
    ),
  },
];
